export function normaliseStringNumber(str: string | number) {
    if (typeof str === 'string') {
        return str.replaceAll(' ', '').replaceAll(',', '.');
    }
    return str;
}
